// src/app/settings/integrations/skeletonIntegrationsTab/index.js
import React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

import "react-loading-skeleton/dist/skeleton.css";
import styles from "../styles.js";

const IntegrationsTabSkeleton = ({ providerNumber = 6 }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.integrationsContent}>
      {Array.from({ length: providerNumber }).map((_, idx) => (
        <div className={classes.skeletonIntegrationCard} key={idx}>
          <div className={classes.skeletonLogoDiv}>
            <div className={classes.logoSvg}>
              <Skeleton width={40} height={40} circle />
            </div>
            <div>
                <p className={classes.logoTxt}>
                <Skeleton width={120} height={18} />
                </p>
                <p className={classes.skeletonMoreTxt}>
                <Skeleton width={120} height={14} />
                </p>
            </div>
          </div>

          <div className={classes.skeletonButtonContainer}>
            <Skeleton
              width={44}
              height={24}
              borderRadius={999}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default IntegrationsTabSkeleton;